import { BroadcastReceiverTypeEnum, BroadcastUserTypeEnum } from 'app/models';

export class BroadcastReceiverTypeModel {
    public static BroadcastReceiverTypeList: Array<any> = [
        { name: 'Signed Up In Last X Day', value: BroadcastReceiverTypeEnum.SignedUpInLastXDay },
        { name: 'Currently Online Location', value: BroadcastReceiverTypeEnum.CurrentlyOnlineLocation },
        {
            name: 'Havent Logged In X Days', value: BroadcastReceiverTypeEnum.HaventLoggedInXDays
        },
        { name: 'All', value: BroadcastReceiverTypeEnum.All },
        { name: 'Currently Online', value: BroadcastReceiverTypeEnum.CurrentlyOnline },
        { name: 'Passenger 2W', value: BroadcastReceiverTypeEnum.Passenger2W },
        { name: 'Passenger 4W', value: BroadcastReceiverTypeEnum.Passenger4W },
        { name: 'Active', value: BroadcastReceiverTypeEnum.Active },
        { name: 'Registration', value: BroadcastReceiverTypeEnum.Registration },
        { name: 'Campaign Drivers', value: BroadcastReceiverTypeEnum.CampaignDrivers },
        { name: 'Xpress For Ride', value: BroadcastReceiverTypeEnum.XpressForRide },
        { name: 'Geo-tagging', value: BroadcastReceiverTypeEnum.GeoTagging }
    ];

    public static BroadcastReceiverTypeByUserTypeList(userType: BroadcastUserTypeEnum) {
        switch (userType) {
            case BroadcastUserTypeEnum.Drivers:
                return [
                    { name: 'Drivers Signed Up In Last X Day', value: BroadcastReceiverTypeEnum.SignedUpInLastXDay },
                    { name: 'Drivers Currently Online Location', value: BroadcastReceiverTypeEnum.CurrentlyOnlineLocation },
                    {
                        name: 'Drivers Havent Logged In X Days', value: BroadcastReceiverTypeEnum.HaventLoggedInXDays
                    },
                    { name: 'All Drivers', value: BroadcastReceiverTypeEnum.All },
                    { name: 'Drivers Currently Online', value: BroadcastReceiverTypeEnum.CurrentlyOnline },
                    { name: 'Passenger 2W', value: BroadcastReceiverTypeEnum.Passenger2W },
                    { name: 'Passenger 4W', value: BroadcastReceiverTypeEnum.Passenger4W },
                    { name: 'Active Drivers', value: BroadcastReceiverTypeEnum.Active },
                    { name: 'Registration', value: BroadcastReceiverTypeEnum.Registration },
                    { name: 'Campaign Drivers', value: BroadcastReceiverTypeEnum.CampaignDrivers },
					{ name: 'Xpress For Ride', value: BroadcastReceiverTypeEnum.XpressForRide },
					{ name: 'Banned 2W Drivers - April 2026', value: BroadcastReceiverTypeEnum.Ban2WDriversApril26 }
                ];
            case BroadcastUserTypeEnum.Customers:
                return [
                    { name: 'Customers Signed Up In Last X Day', value: BroadcastReceiverTypeEnum.SignedUpInLastXDay },
                    { name: 'Customers Currently Online Location', value: BroadcastReceiverTypeEnum.CurrentlyOnlineLocation },
                    {
                        name: 'Customers Havent Logged In X Days', value: BroadcastReceiverTypeEnum.HaventLoggedInXDays
                    },
                    { name: 'All Customers', value: BroadcastReceiverTypeEnum.All },
                    { name: 'Customers Currently Online', value: BroadcastReceiverTypeEnum.CurrentlyOnline },
                    { name: 'Geo-tagging Customers', value: BroadcastReceiverTypeEnum.GeoTagging }
                ];
            default:
                return [
                    { name: 'Signed Up In Last X Day', value: BroadcastReceiverTypeEnum.SignedUpInLastXDay },
                    { name: 'Currently Online Location', value: BroadcastReceiverTypeEnum.CurrentlyOnlineLocation },
                    {
                        name: 'Havent Logged In X Days', value: BroadcastReceiverTypeEnum.HaventLoggedInXDays
                    },
                    { name: 'All', value: BroadcastReceiverTypeEnum.All },
                    { name: 'Currently Online', value: BroadcastReceiverTypeEnum.CurrentlyOnline },
                    { name: 'Passenger 2W', value: BroadcastReceiverTypeEnum.Passenger2W },
                    { name: 'Passenger 4W', value: BroadcastReceiverTypeEnum.Passenger4W },
                    { name: 'Active', value: BroadcastReceiverTypeEnum.Active },
                    { name: 'Registration', value: BroadcastReceiverTypeEnum.Registration },
                    { name: 'Campaign Drivers', value: BroadcastReceiverTypeEnum.CampaignDrivers },
                    { name: 'Xpress For Ride', value: BroadcastReceiverTypeEnum.XpressForRide }
                ];
        }
    }
}
